
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Chip from '@/components/UI/chip/Chip.vue';

@Component({
  components: {
    Chip,
  },
})
export default class FiltersBar extends Vue {
  public filters: string[] = [];
  public filtersAttributes: string[] = [];

  public clickChip(filter: string): void {
    const filterIdx = this.filters.indexOf(filter);
    filterIdx === -1 ? this.filters.push(filter) : this.filters.splice(filterIdx, 1);
    this.$emit('updateFilters', this.filters);
  }

  public clickChipAttr(filter: string): void {
    const filterIdx = this.filtersAttributes.indexOf(filter);
    filterIdx === -1 ? this.filtersAttributes.push(filter) : this.filtersAttributes.splice(filterIdx, 1);
    this.$emit('updateAttributeFilters', this.filtersAttributes);
  }
}
